(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').config(Config);

  function Config($stateProvider) {
    $stateProvider
      .state('visualizacao.principal', {
          url: "/principal",
          templateUrl: "module/validacao/visualizacao/principal/principal.tab.html",
          controller: 'AbaPrincipalVisualizacao',
          controllerAs: 'vm'
      })
    ;
  }

})();
